"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgSetSmallLiquidationSize = exports.MsgSetMinimumCloseFactorResponse = exports.MsgSetMinimumCloseFactor = exports.MsgSetCompleteLiquidationThresholdResponse = exports.MsgSetCompleteLiquidationThreshold = exports.MsgReturnStablecoinResponse = exports.MsgReturnStablecoin = exports.MsgMintStablecoinResponse = exports.MsgMintStablecoin = exports.MsgSetStablecoinInterestRateResponse = exports.MsgSetStablecoinInterestRate = exports.MsgSetStablecoinMintCapResponse = exports.MsgSetStablecoinMintCap = exports.MsgRepayAssetWithCollateralResponse = exports.MsgRepayAssetWithCollateral = exports.MsgRepayAssetWithCdpTokensResponse = exports.MsgRepayAssetWithCdpTokens = exports.MsgSetInterestFeeResponse = exports.MsgSetInterestFee = exports.MsgSetLiquidationFeeResponse = exports.MsgSetLiquidationFee = exports.MsgLiquidateCollateralResponse = exports.MsgLiquidateCollateral = exports.MsgUnlockCollateralAndWithdrawAssetResponse = exports.MsgUnlockCollateralAndWithdrawAsset = exports.MsgSupplyAssetAndLockCollateralResponse = exports.MsgSupplyAssetAndLockCollateral = exports.MsgRepayAssetResponse = exports.MsgRepayAsset = exports.MsgBorrowAssetResponse = exports.MsgBorrowAsset = exports.MsgUnlockCollateralResponse = exports.MsgUnlockCollateral = exports.MsgLockCollateralResponse = exports.MsgLockCollateral = exports.MsgWithdrawAssetResponse = exports.MsgWithdrawAsset = exports.MsgSupplyAssetResponse = exports.MsgSupplyAsset = exports.MsgUpdateAssetResponse = exports.MsgUpdateAsset = exports.MsgAddAssetResponse = exports.MsgAddAsset = exports.MsgRemoveRateStrategyResponse = exports.MsgRemoveRateStrategy = exports.MsgUpdateRateStrategyResponse = exports.MsgUpdateRateStrategy = exports.MsgAddRateStrategyResponse = exports.MsgAddRateStrategy = exports.protobufPackage = void 0;
exports.MsgClientImpl = exports.MsgConvertTokenInCdpToGroupTokensResponse = exports.MsgConvertTokenInCdpToGroupTokens = exports.MsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse = exports.MsgLiquidateCollateralWithStablecoinAndInterestInCollateral = exports.MsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse = exports.MsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens = exports.MsgReturnStablecoinWithInterestInCdpTokensResponse = exports.MsgReturnStablecoinWithInterestInCdpTokens = exports.MsgReturnStablecoinWithInterestInCollateralResponse = exports.MsgReturnStablecoinWithInterestInCollateral = exports.MsgSetCdpPausedResponse = exports.MsgSetCdpPaused = exports.MsgSetStalePriceGracePeriodResponse = exports.MsgSetStalePriceGracePeriod = exports.MsgClaimRewardsResponse = exports.MsgClaimRewards = exports.MsgUpdateRewardSchemeResponse = exports.MsgUpdateRewardScheme = exports.MsgCreateRewardSchemeResponse = exports.MsgCreateRewardScheme = exports.MsgLiquidateCollateralWithStablecoinResponse = exports.MsgLiquidateCollateralWithStablecoin = exports.MsgLiquidateCollateralWithCollateralResponse = exports.MsgLiquidateCollateralWithCollateral = exports.MsgLiquidateCollateralWithCdpTokensResponse = exports.MsgLiquidateCollateralWithCdpTokens = exports.MsgSetSmallLiquidationSizeResponse = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const rate_strategy_params_1 = require("./rate_strategy_params");
const asset_params_1 = require("./asset_params");
const reward_scheme_1 = require("./reward_scheme");
exports.protobufPackage = "Switcheo.carbon.cdp";
const baseMsgAddRateStrategy = { creator: "" };
exports.MsgAddRateStrategy = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddRateStrategy);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddRateStrategy);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgAddRateStrategy);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        return message;
    },
};
const baseMsgAddRateStrategyResponse = {};
exports.MsgAddRateStrategyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddRateStrategyResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddRateStrategyResponse);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgAddRateStrategyResponse);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdateRateStrategy = { creator: "" };
exports.MsgUpdateRateStrategy = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRateStrategy);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateRateStrategy);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateRateStrategy);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdateRateStrategyResponse = {};
exports.MsgUpdateRateStrategyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRateStrategyResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateRateStrategyResponse);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateRateStrategyResponse);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        return message;
    },
};
const baseMsgRemoveRateStrategy = { creator: "", name: "" };
exports.MsgRemoveRateStrategy = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveRateStrategy);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveRateStrategy);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveRateStrategy);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveRateStrategyResponse = { name: "" };
exports.MsgRemoveRateStrategyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveRateStrategyResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveRateStrategyResponse);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgRemoveRateStrategyResponse);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgAddAsset = { creator: "" };
exports.MsgAddAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.assetParams !== undefined) {
            asset_params_1.AssetParams.encode(message.assetParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.assetParams = asset_params_1.AssetParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromJSON(object.assetParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.AssetParams.toJSON(message.assetParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgAddAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromPartial(object.assetParams)
                : undefined;
        return message;
    },
};
const baseMsgAddAssetResponse = {};
exports.MsgAddAssetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.assetParams !== undefined) {
            asset_params_1.AssetParams.encode(message.assetParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetParams = asset_params_1.AssetParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddAssetResponse);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromJSON(object.assetParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.AssetParams.toJSON(message.assetParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgAddAssetResponse);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromPartial(object.assetParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdateAsset = { creator: "" };
exports.MsgUpdateAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.assetParams !== undefined) {
            asset_params_1.UpdateAssetParams.encode(message.assetParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.assetParams = asset_params_1.UpdateAssetParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.UpdateAssetParams.fromJSON(object.assetParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.UpdateAssetParams.toJSON(message.assetParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.UpdateAssetParams.fromPartial(object.assetParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdateAssetResponse = {};
exports.MsgUpdateAssetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.assetParams !== undefined) {
            asset_params_1.AssetParams.encode(message.assetParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetParams = asset_params_1.AssetParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateAssetResponse);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromJSON(object.assetParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.AssetParams.toJSON(message.assetParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateAssetResponse);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromPartial(object.assetParams)
                : undefined;
        return message;
    },
};
const baseMsgSupplyAsset = { creator: "", denom: "", amount: "" };
exports.MsgSupplyAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSupplyAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSupplyAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgSupplyAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgSupplyAssetResponse = {};
exports.MsgSupplyAssetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSupplyAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSupplyAssetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSupplyAssetResponse);
        return message;
    },
};
const baseMsgWithdrawAsset = { creator: "", cdpDenom: "", amount: "" };
exports.MsgWithdrawAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(18).string(message.cdpDenom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.cdpDenom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgWithdrawAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgWithdrawAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.cdpDenom = (_b = object.cdpDenom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgWithdrawAssetResponse = {};
exports.MsgWithdrawAssetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgWithdrawAssetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgWithdrawAssetResponse);
        return message;
    },
};
const baseMsgLockCollateral = { creator: "", cdpDenom: "", amount: "" };
exports.MsgLockCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(18).string(message.cdpDenom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLockCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.cdpDenom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLockCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgLockCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.cdpDenom = (_b = object.cdpDenom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgLockCollateralResponse = {};
exports.MsgLockCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLockCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLockCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLockCollateralResponse);
        return message;
    },
};
const baseMsgUnlockCollateral = {
    creator: "",
    cdpDenom: "",
    amount: "",
};
exports.MsgUnlockCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(18).string(message.cdpDenom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnlockCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.cdpDenom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUnlockCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgUnlockCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.cdpDenom = (_b = object.cdpDenom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgUnlockCollateralResponse = {};
exports.MsgUnlockCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnlockCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUnlockCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUnlockCollateralResponse);
        return message;
    },
};
const baseMsgBorrowAsset = { creator: "", denom: "", amount: "" };
exports.MsgBorrowAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBorrowAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgBorrowAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgBorrowAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgBorrowAssetResponse = {};
exports.MsgBorrowAssetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBorrowAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgBorrowAssetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgBorrowAssetResponse);
        return message;
    },
};
const baseMsgRepayAsset = {
    creator: "",
    denom: "",
    amount: "",
    debtor: "",
};
exports.MsgRepayAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.debtor !== "") {
            writer.uint32(34).string(message.debtor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRepayAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.debtor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRepayAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgRepayAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        message.debtor = (_d = object.debtor) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgRepayAssetResponse = {};
exports.MsgRepayAssetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRepayAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRepayAssetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRepayAssetResponse);
        return message;
    },
};
const baseMsgSupplyAssetAndLockCollateral = {
    creator: "",
    denom: "",
    supplyAmount: "",
    lockAmount: "",
};
exports.MsgSupplyAssetAndLockCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.supplyAmount !== "") {
            writer.uint32(26).string(message.supplyAmount);
        }
        if (message.lockAmount !== "") {
            writer.uint32(34).string(message.lockAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSupplyAssetAndLockCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.supplyAmount = reader.string();
                    break;
                case 4:
                    message.lockAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSupplyAssetAndLockCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.supplyAmount =
            object.supplyAmount !== undefined && object.supplyAmount !== null
                ? String(object.supplyAmount)
                : "";
        message.lockAmount =
            object.lockAmount !== undefined && object.lockAmount !== null
                ? String(object.lockAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.supplyAmount !== undefined &&
            (obj.supplyAmount = message.supplyAmount);
        message.lockAmount !== undefined && (obj.lockAmount = message.lockAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgSupplyAssetAndLockCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.supplyAmount = (_c = object.supplyAmount) !== null && _c !== void 0 ? _c : "";
        message.lockAmount = (_d = object.lockAmount) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgSupplyAssetAndLockCollateralResponse = {};
exports.MsgSupplyAssetAndLockCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSupplyAssetAndLockCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSupplyAssetAndLockCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSupplyAssetAndLockCollateralResponse);
        return message;
    },
};
const baseMsgUnlockCollateralAndWithdrawAsset = {
    creator: "",
    cdpDenom: "",
    unlockAmount: "",
    withdrawAmount: "",
};
exports.MsgUnlockCollateralAndWithdrawAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(18).string(message.cdpDenom);
        }
        if (message.unlockAmount !== "") {
            writer.uint32(26).string(message.unlockAmount);
        }
        if (message.withdrawAmount !== "") {
            writer.uint32(34).string(message.withdrawAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnlockCollateralAndWithdrawAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.cdpDenom = reader.string();
                    break;
                case 3:
                    message.unlockAmount = reader.string();
                    break;
                case 4:
                    message.withdrawAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUnlockCollateralAndWithdrawAsset);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.unlockAmount =
            object.unlockAmount !== undefined && object.unlockAmount !== null
                ? String(object.unlockAmount)
                : "";
        message.withdrawAmount =
            object.withdrawAmount !== undefined && object.withdrawAmount !== null
                ? String(object.withdrawAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.unlockAmount !== undefined &&
            (obj.unlockAmount = message.unlockAmount);
        message.withdrawAmount !== undefined &&
            (obj.withdrawAmount = message.withdrawAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgUnlockCollateralAndWithdrawAsset);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.cdpDenom = (_b = object.cdpDenom) !== null && _b !== void 0 ? _b : "";
        message.unlockAmount = (_c = object.unlockAmount) !== null && _c !== void 0 ? _c : "";
        message.withdrawAmount = (_d = object.withdrawAmount) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgUnlockCollateralAndWithdrawAssetResponse = {};
exports.MsgUnlockCollateralAndWithdrawAssetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnlockCollateralAndWithdrawAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUnlockCollateralAndWithdrawAssetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUnlockCollateralAndWithdrawAssetResponse);
        return message;
    },
};
const baseMsgLiquidateCollateral = {
    creator: "",
    debtor: "",
    collateralDenom: "",
    minCollateralAmount: "",
    debtDenom: "",
    debtAmount: "",
};
exports.MsgLiquidateCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.minCollateralAmount !== "") {
            writer.uint32(34).string(message.minCollateralAmount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(42).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(50).string(message.debtAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.minCollateralAmount = reader.string();
                    break;
                case 5:
                    message.debtDenom = reader.string();
                    break;
                case 6:
                    message.debtAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLiquidateCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.minCollateralAmount =
            object.minCollateralAmount !== undefined &&
                object.minCollateralAmount !== null
                ? String(object.minCollateralAmount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.minCollateralAmount !== undefined &&
            (obj.minCollateralAmount = message.minCollateralAmount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseMsgLiquidateCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.minCollateralAmount = (_d = object.minCollateralAmount) !== null && _d !== void 0 ? _d : "";
        message.debtDenom = (_e = object.debtDenom) !== null && _e !== void 0 ? _e : "";
        message.debtAmount = (_f = object.debtAmount) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
const baseMsgLiquidateCollateralResponse = {};
exports.MsgLiquidateCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralResponse);
        return message;
    },
};
const baseMsgSetLiquidationFee = { creator: "", liquidationFee: "" };
exports.MsgSetLiquidationFee = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.liquidationFee !== "") {
            writer.uint32(18).string(message.liquidationFee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetLiquidationFee);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.liquidationFee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetLiquidationFee);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.liquidationFee =
            object.liquidationFee !== undefined && object.liquidationFee !== null
                ? String(object.liquidationFee)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.liquidationFee !== undefined &&
            (obj.liquidationFee = message.liquidationFee);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetLiquidationFee);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.liquidationFee = (_b = object.liquidationFee) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetLiquidationFeeResponse = {};
exports.MsgSetLiquidationFeeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetLiquidationFeeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetLiquidationFeeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetLiquidationFeeResponse);
        return message;
    },
};
const baseMsgSetInterestFee = { creator: "", interestFee: "" };
exports.MsgSetInterestFee = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.interestFee !== "") {
            writer.uint32(18).string(message.interestFee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetInterestFee);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.interestFee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetInterestFee);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.interestFee =
            object.interestFee !== undefined && object.interestFee !== null
                ? String(object.interestFee)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.interestFee !== undefined &&
            (obj.interestFee = message.interestFee);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetInterestFee);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.interestFee = (_b = object.interestFee) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetInterestFeeResponse = {};
exports.MsgSetInterestFeeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetInterestFeeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetInterestFeeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetInterestFeeResponse);
        return message;
    },
};
const baseMsgRepayAssetWithCdpTokens = {
    creator: "",
    debtor: "",
    debtDenom: "",
    cdpDenom: "",
    cdpAmount: "",
};
exports.MsgRepayAssetWithCdpTokens = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.debtDenom !== "") {
            writer.uint32(26).string(message.debtDenom);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(34).string(message.cdpDenom);
        }
        if (message.cdpAmount !== "") {
            writer.uint32(42).string(message.cdpAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRepayAssetWithCdpTokens);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.debtDenom = reader.string();
                    break;
                case 4:
                    message.cdpDenom = reader.string();
                    break;
                case 5:
                    message.cdpAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRepayAssetWithCdpTokens);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.cdpAmount =
            object.cdpAmount !== undefined && object.cdpAmount !== null
                ? String(object.cdpAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.cdpAmount !== undefined && (obj.cdpAmount = message.cdpAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgRepayAssetWithCdpTokens);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.debtDenom = (_c = object.debtDenom) !== null && _c !== void 0 ? _c : "";
        message.cdpDenom = (_d = object.cdpDenom) !== null && _d !== void 0 ? _d : "";
        message.cdpAmount = (_e = object.cdpAmount) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgRepayAssetWithCdpTokensResponse = {};
exports.MsgRepayAssetWithCdpTokensResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRepayAssetWithCdpTokensResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRepayAssetWithCdpTokensResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRepayAssetWithCdpTokensResponse);
        return message;
    },
};
const baseMsgRepayAssetWithCollateral = {
    creator: "",
    debtor: "",
    debtDenom: "",
    cdpDenom: "",
    cdpAmount: "",
};
exports.MsgRepayAssetWithCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.debtDenom !== "") {
            writer.uint32(26).string(message.debtDenom);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(34).string(message.cdpDenom);
        }
        if (message.cdpAmount !== "") {
            writer.uint32(42).string(message.cdpAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRepayAssetWithCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.debtDenom = reader.string();
                    break;
                case 4:
                    message.cdpDenom = reader.string();
                    break;
                case 5:
                    message.cdpAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRepayAssetWithCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.cdpAmount =
            object.cdpAmount !== undefined && object.cdpAmount !== null
                ? String(object.cdpAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.cdpAmount !== undefined && (obj.cdpAmount = message.cdpAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgRepayAssetWithCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.debtDenom = (_c = object.debtDenom) !== null && _c !== void 0 ? _c : "";
        message.cdpDenom = (_d = object.cdpDenom) !== null && _d !== void 0 ? _d : "";
        message.cdpAmount = (_e = object.cdpAmount) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgRepayAssetWithCollateralResponse = {};
exports.MsgRepayAssetWithCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRepayAssetWithCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRepayAssetWithCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRepayAssetWithCollateralResponse);
        return message;
    },
};
const baseMsgSetStablecoinMintCap = {
    creator: "",
    stablecoinMintCap: "",
};
exports.MsgSetStablecoinMintCap = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.stablecoinMintCap !== "") {
            writer.uint32(18).string(message.stablecoinMintCap);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStablecoinMintCap);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.stablecoinMintCap = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetStablecoinMintCap);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.stablecoinMintCap =
            object.stablecoinMintCap !== undefined &&
                object.stablecoinMintCap !== null
                ? String(object.stablecoinMintCap)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.stablecoinMintCap !== undefined &&
            (obj.stablecoinMintCap = message.stablecoinMintCap);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetStablecoinMintCap);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.stablecoinMintCap = (_b = object.stablecoinMintCap) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetStablecoinMintCapResponse = {};
exports.MsgSetStablecoinMintCapResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStablecoinMintCapResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetStablecoinMintCapResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetStablecoinMintCapResponse);
        return message;
    },
};
const baseMsgSetStablecoinInterestRate = {
    creator: "",
    stablecoinInterestRate: "",
};
exports.MsgSetStablecoinInterestRate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.stablecoinInterestRate !== "") {
            writer.uint32(18).string(message.stablecoinInterestRate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStablecoinInterestRate);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.stablecoinInterestRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetStablecoinInterestRate);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.stablecoinInterestRate =
            object.stablecoinInterestRate !== undefined &&
                object.stablecoinInterestRate !== null
                ? String(object.stablecoinInterestRate)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.stablecoinInterestRate !== undefined &&
            (obj.stablecoinInterestRate = message.stablecoinInterestRate);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetStablecoinInterestRate);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.stablecoinInterestRate = (_b = object.stablecoinInterestRate) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetStablecoinInterestRateResponse = {};
exports.MsgSetStablecoinInterestRateResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStablecoinInterestRateResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetStablecoinInterestRateResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetStablecoinInterestRateResponse);
        return message;
    },
};
const baseMsgMintStablecoin = { creator: "", amount: "" };
exports.MsgMintStablecoin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgMintStablecoin);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgMintStablecoin);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgMintStablecoin);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgMintStablecoinResponse = {};
exports.MsgMintStablecoinResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgMintStablecoinResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgMintStablecoinResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgMintStablecoinResponse);
        return message;
    },
};
const baseMsgReturnStablecoin = {
    creator: "",
    principalAmount: "",
    interestDenom: "",
    interestAmount: "",
    debtor: "",
};
exports.MsgReturnStablecoin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.principalAmount !== "") {
            writer.uint32(18).string(message.principalAmount);
        }
        if (message.interestDenom !== "") {
            writer.uint32(26).string(message.interestDenom);
        }
        if (message.interestAmount !== "") {
            writer.uint32(34).string(message.interestAmount);
        }
        if (message.debtor !== "") {
            writer.uint32(42).string(message.debtor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgReturnStablecoin);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.principalAmount = reader.string();
                    break;
                case 3:
                    message.interestDenom = reader.string();
                    break;
                case 4:
                    message.interestAmount = reader.string();
                    break;
                case 5:
                    message.debtor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgReturnStablecoin);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.principalAmount =
            object.principalAmount !== undefined && object.principalAmount !== null
                ? String(object.principalAmount)
                : "";
        message.interestDenom =
            object.interestDenom !== undefined && object.interestDenom !== null
                ? String(object.interestDenom)
                : "";
        message.interestAmount =
            object.interestAmount !== undefined && object.interestAmount !== null
                ? String(object.interestAmount)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.principalAmount !== undefined &&
            (obj.principalAmount = message.principalAmount);
        message.interestDenom !== undefined &&
            (obj.interestDenom = message.interestDenom);
        message.interestAmount !== undefined &&
            (obj.interestAmount = message.interestAmount);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgReturnStablecoin);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.principalAmount = (_b = object.principalAmount) !== null && _b !== void 0 ? _b : "";
        message.interestDenom = (_c = object.interestDenom) !== null && _c !== void 0 ? _c : "";
        message.interestAmount = (_d = object.interestAmount) !== null && _d !== void 0 ? _d : "";
        message.debtor = (_e = object.debtor) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgReturnStablecoinResponse = {};
exports.MsgReturnStablecoinResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgReturnStablecoinResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgReturnStablecoinResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgReturnStablecoinResponse);
        return message;
    },
};
const baseMsgSetCompleteLiquidationThreshold = {
    creator: "",
    completeLiquidationThreshold: "",
};
exports.MsgSetCompleteLiquidationThreshold = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.completeLiquidationThreshold !== "") {
            writer.uint32(18).string(message.completeLiquidationThreshold);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetCompleteLiquidationThreshold);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.completeLiquidationThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetCompleteLiquidationThreshold);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.completeLiquidationThreshold =
            object.completeLiquidationThreshold !== undefined &&
                object.completeLiquidationThreshold !== null
                ? String(object.completeLiquidationThreshold)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.completeLiquidationThreshold !== undefined &&
            (obj.completeLiquidationThreshold = message.completeLiquidationThreshold);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetCompleteLiquidationThreshold);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.completeLiquidationThreshold =
            (_b = object.completeLiquidationThreshold) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetCompleteLiquidationThresholdResponse = {};
exports.MsgSetCompleteLiquidationThresholdResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetCompleteLiquidationThresholdResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetCompleteLiquidationThresholdResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetCompleteLiquidationThresholdResponse);
        return message;
    },
};
const baseMsgSetMinimumCloseFactor = {
    creator: "",
    minimumCloseFactor: "",
};
exports.MsgSetMinimumCloseFactor = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.minimumCloseFactor !== "") {
            writer.uint32(18).string(message.minimumCloseFactor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetMinimumCloseFactor);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.minimumCloseFactor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetMinimumCloseFactor);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.minimumCloseFactor =
            object.minimumCloseFactor !== undefined &&
                object.minimumCloseFactor !== null
                ? String(object.minimumCloseFactor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.minimumCloseFactor !== undefined &&
            (obj.minimumCloseFactor = message.minimumCloseFactor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetMinimumCloseFactor);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.minimumCloseFactor = (_b = object.minimumCloseFactor) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetMinimumCloseFactorResponse = {};
exports.MsgSetMinimumCloseFactorResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetMinimumCloseFactorResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetMinimumCloseFactorResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetMinimumCloseFactorResponse);
        return message;
    },
};
const baseMsgSetSmallLiquidationSize = {
    creator: "",
    smallLiquidationSize: "",
};
exports.MsgSetSmallLiquidationSize = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.smallLiquidationSize !== "") {
            writer.uint32(18).string(message.smallLiquidationSize);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetSmallLiquidationSize);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.smallLiquidationSize = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetSmallLiquidationSize);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.smallLiquidationSize =
            object.smallLiquidationSize !== undefined &&
                object.smallLiquidationSize !== null
                ? String(object.smallLiquidationSize)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.smallLiquidationSize !== undefined &&
            (obj.smallLiquidationSize = message.smallLiquidationSize);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetSmallLiquidationSize);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.smallLiquidationSize = (_b = object.smallLiquidationSize) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetSmallLiquidationSizeResponse = {};
exports.MsgSetSmallLiquidationSizeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetSmallLiquidationSizeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetSmallLiquidationSizeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetSmallLiquidationSizeResponse);
        return message;
    },
};
const baseMsgLiquidateCollateralWithCdpTokens = {
    creator: "",
    debtor: "",
    collateralDenom: "",
    minCollateralAmount: "",
    debtDenom: "",
    debtAmount: "",
    debtCollateralDenom: "",
    debtCollateralAmount: "",
};
exports.MsgLiquidateCollateralWithCdpTokens = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.minCollateralAmount !== "") {
            writer.uint32(34).string(message.minCollateralAmount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(42).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(50).string(message.debtAmount);
        }
        if (message.debtCollateralDenom !== "") {
            writer.uint32(58).string(message.debtCollateralDenom);
        }
        if (message.debtCollateralAmount !== "") {
            writer.uint32(66).string(message.debtCollateralAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCdpTokens);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.minCollateralAmount = reader.string();
                    break;
                case 5:
                    message.debtDenom = reader.string();
                    break;
                case 6:
                    message.debtAmount = reader.string();
                    break;
                case 7:
                    message.debtCollateralDenom = reader.string();
                    break;
                case 8:
                    message.debtCollateralAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCdpTokens);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.minCollateralAmount =
            object.minCollateralAmount !== undefined &&
                object.minCollateralAmount !== null
                ? String(object.minCollateralAmount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.debtCollateralDenom =
            object.debtCollateralDenom !== undefined &&
                object.debtCollateralDenom !== null
                ? String(object.debtCollateralDenom)
                : "";
        message.debtCollateralAmount =
            object.debtCollateralAmount !== undefined &&
                object.debtCollateralAmount !== null
                ? String(object.debtCollateralAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.minCollateralAmount !== undefined &&
            (obj.minCollateralAmount = message.minCollateralAmount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.debtCollateralDenom !== undefined &&
            (obj.debtCollateralDenom = message.debtCollateralDenom);
        message.debtCollateralAmount !== undefined &&
            (obj.debtCollateralAmount = message.debtCollateralAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCdpTokens);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.minCollateralAmount = (_d = object.minCollateralAmount) !== null && _d !== void 0 ? _d : "";
        message.debtDenom = (_e = object.debtDenom) !== null && _e !== void 0 ? _e : "";
        message.debtAmount = (_f = object.debtAmount) !== null && _f !== void 0 ? _f : "";
        message.debtCollateralDenom = (_g = object.debtCollateralDenom) !== null && _g !== void 0 ? _g : "";
        message.debtCollateralAmount = (_h = object.debtCollateralAmount) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseMsgLiquidateCollateralWithCdpTokensResponse = {};
exports.MsgLiquidateCollateralWithCdpTokensResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCdpTokensResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCdpTokensResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCdpTokensResponse);
        return message;
    },
};
const baseMsgLiquidateCollateralWithCollateral = {
    creator: "",
    debtor: "",
    collateralDenom: "",
    minCollateralAmount: "",
    debtDenom: "",
    debtAmount: "",
    debtCollateralDenom: "",
    debtCollateralAmount: "",
};
exports.MsgLiquidateCollateralWithCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.minCollateralAmount !== "") {
            writer.uint32(34).string(message.minCollateralAmount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(42).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(50).string(message.debtAmount);
        }
        if (message.debtCollateralDenom !== "") {
            writer.uint32(58).string(message.debtCollateralDenom);
        }
        if (message.debtCollateralAmount !== "") {
            writer.uint32(66).string(message.debtCollateralAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.minCollateralAmount = reader.string();
                    break;
                case 5:
                    message.debtDenom = reader.string();
                    break;
                case 6:
                    message.debtAmount = reader.string();
                    break;
                case 7:
                    message.debtCollateralDenom = reader.string();
                    break;
                case 8:
                    message.debtCollateralAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.minCollateralAmount =
            object.minCollateralAmount !== undefined &&
                object.minCollateralAmount !== null
                ? String(object.minCollateralAmount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.debtCollateralDenom =
            object.debtCollateralDenom !== undefined &&
                object.debtCollateralDenom !== null
                ? String(object.debtCollateralDenom)
                : "";
        message.debtCollateralAmount =
            object.debtCollateralAmount !== undefined &&
                object.debtCollateralAmount !== null
                ? String(object.debtCollateralAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.minCollateralAmount !== undefined &&
            (obj.minCollateralAmount = message.minCollateralAmount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.debtCollateralDenom !== undefined &&
            (obj.debtCollateralDenom = message.debtCollateralDenom);
        message.debtCollateralAmount !== undefined &&
            (obj.debtCollateralAmount = message.debtCollateralAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.minCollateralAmount = (_d = object.minCollateralAmount) !== null && _d !== void 0 ? _d : "";
        message.debtDenom = (_e = object.debtDenom) !== null && _e !== void 0 ? _e : "";
        message.debtAmount = (_f = object.debtAmount) !== null && _f !== void 0 ? _f : "";
        message.debtCollateralDenom = (_g = object.debtCollateralDenom) !== null && _g !== void 0 ? _g : "";
        message.debtCollateralAmount = (_h = object.debtCollateralAmount) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseMsgLiquidateCollateralWithCollateralResponse = {};
exports.MsgLiquidateCollateralWithCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithCollateralResponse);
        return message;
    },
};
const baseMsgLiquidateCollateralWithStablecoin = {
    creator: "",
    debtor: "",
    collateralDenom: "",
    minCollateralAmount: "",
    debtDenom: "",
    debtAmount: "",
    interestDenom: "",
    interestAmount: "",
};
exports.MsgLiquidateCollateralWithStablecoin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.minCollateralAmount !== "") {
            writer.uint32(34).string(message.minCollateralAmount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(42).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(50).string(message.debtAmount);
        }
        if (message.interestDenom !== "") {
            writer.uint32(58).string(message.interestDenom);
        }
        if (message.interestAmount !== "") {
            writer.uint32(66).string(message.interestAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoin);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.minCollateralAmount = reader.string();
                    break;
                case 5:
                    message.debtDenom = reader.string();
                    break;
                case 6:
                    message.debtAmount = reader.string();
                    break;
                case 7:
                    message.interestDenom = reader.string();
                    break;
                case 8:
                    message.interestAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoin);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.minCollateralAmount =
            object.minCollateralAmount !== undefined &&
                object.minCollateralAmount !== null
                ? String(object.minCollateralAmount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.interestDenom =
            object.interestDenom !== undefined && object.interestDenom !== null
                ? String(object.interestDenom)
                : "";
        message.interestAmount =
            object.interestAmount !== undefined && object.interestAmount !== null
                ? String(object.interestAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.minCollateralAmount !== undefined &&
            (obj.minCollateralAmount = message.minCollateralAmount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.interestDenom !== undefined &&
            (obj.interestDenom = message.interestDenom);
        message.interestAmount !== undefined &&
            (obj.interestAmount = message.interestAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoin);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.minCollateralAmount = (_d = object.minCollateralAmount) !== null && _d !== void 0 ? _d : "";
        message.debtDenom = (_e = object.debtDenom) !== null && _e !== void 0 ? _e : "";
        message.debtAmount = (_f = object.debtAmount) !== null && _f !== void 0 ? _f : "";
        message.interestDenom = (_g = object.interestDenom) !== null && _g !== void 0 ? _g : "";
        message.interestAmount = (_h = object.interestAmount) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseMsgLiquidateCollateralWithStablecoinResponse = {};
exports.MsgLiquidateCollateralWithStablecoinResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinResponse);
        return message;
    },
};
const baseMsgCreateRewardScheme = { creator: "" };
exports.MsgCreateRewardScheme = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.createRewardSchemeParams !== undefined) {
            reward_scheme_1.CreateRewardSchemeParams.encode(message.createRewardSchemeParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateRewardScheme);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.createRewardSchemeParams = reward_scheme_1.CreateRewardSchemeParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateRewardScheme);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.createRewardSchemeParams =
            object.createRewardSchemeParams !== undefined &&
                object.createRewardSchemeParams !== null
                ? reward_scheme_1.CreateRewardSchemeParams.fromJSON(object.createRewardSchemeParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.createRewardSchemeParams !== undefined &&
            (obj.createRewardSchemeParams = message.createRewardSchemeParams
                ? reward_scheme_1.CreateRewardSchemeParams.toJSON(message.createRewardSchemeParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateRewardScheme);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.createRewardSchemeParams =
            object.createRewardSchemeParams !== undefined &&
                object.createRewardSchemeParams !== null
                ? reward_scheme_1.CreateRewardSchemeParams.fromPartial(object.createRewardSchemeParams)
                : undefined;
        return message;
    },
};
const baseMsgCreateRewardSchemeResponse = {};
exports.MsgCreateRewardSchemeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateRewardSchemeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateRewardSchemeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateRewardSchemeResponse);
        return message;
    },
};
const baseMsgUpdateRewardScheme = { updator: "" };
exports.MsgUpdateRewardScheme = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updator !== "") {
            writer.uint32(10).string(message.updator);
        }
        if (message.updateRewardSchemeParams !== undefined) {
            reward_scheme_1.UpdateRewardSchemeParams.encode(message.updateRewardSchemeParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRewardScheme);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.updator = reader.string();
                    break;
                case 2:
                    message.updateRewardSchemeParams = reward_scheme_1.UpdateRewardSchemeParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateRewardScheme);
        message.updator =
            object.updator !== undefined && object.updator !== null
                ? String(object.updator)
                : "";
        message.updateRewardSchemeParams =
            object.updateRewardSchemeParams !== undefined &&
                object.updateRewardSchemeParams !== null
                ? reward_scheme_1.UpdateRewardSchemeParams.fromJSON(object.updateRewardSchemeParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.updator !== undefined && (obj.updator = message.updator);
        message.updateRewardSchemeParams !== undefined &&
            (obj.updateRewardSchemeParams = message.updateRewardSchemeParams
                ? reward_scheme_1.UpdateRewardSchemeParams.toJSON(message.updateRewardSchemeParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateRewardScheme);
        message.updator = (_a = object.updator) !== null && _a !== void 0 ? _a : "";
        message.updateRewardSchemeParams =
            object.updateRewardSchemeParams !== undefined &&
                object.updateRewardSchemeParams !== null
                ? reward_scheme_1.UpdateRewardSchemeParams.fromPartial(object.updateRewardSchemeParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdateRewardSchemeResponse = {};
exports.MsgUpdateRewardSchemeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateRewardSchemeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateRewardSchemeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateRewardSchemeResponse);
        return message;
    },
};
const baseMsgClaimRewards = { creator: "" };
exports.MsgClaimRewards = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgClaimRewards);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgClaimRewards);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgClaimRewards);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgClaimRewardsResponse = {};
exports.MsgClaimRewardsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgClaimRewardsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgClaimRewardsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgClaimRewardsResponse);
        return message;
    },
};
const baseMsgSetStalePriceGracePeriod = {
    creator: "",
    stalePriceGracePeriod: "",
};
exports.MsgSetStalePriceGracePeriod = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.stalePriceGracePeriod !== "") {
            writer.uint32(18).string(message.stalePriceGracePeriod);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStalePriceGracePeriod);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.stalePriceGracePeriod = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetStalePriceGracePeriod);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.stalePriceGracePeriod =
            object.stalePriceGracePeriod !== undefined &&
                object.stalePriceGracePeriod !== null
                ? String(object.stalePriceGracePeriod)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.stalePriceGracePeriod !== undefined &&
            (obj.stalePriceGracePeriod = message.stalePriceGracePeriod);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetStalePriceGracePeriod);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.stalePriceGracePeriod = (_b = object.stalePriceGracePeriod) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgSetStalePriceGracePeriodResponse = {};
exports.MsgSetStalePriceGracePeriodResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStalePriceGracePeriodResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetStalePriceGracePeriodResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetStalePriceGracePeriodResponse);
        return message;
    },
};
const baseMsgSetCdpPaused = { creator: "", cdpPaused: false };
exports.MsgSetCdpPaused = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.cdpPaused === true) {
            writer.uint32(16).bool(message.cdpPaused);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetCdpPaused);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.cdpPaused = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetCdpPaused);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.cdpPaused =
            object.cdpPaused !== undefined && object.cdpPaused !== null
                ? Boolean(object.cdpPaused)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.cdpPaused !== undefined && (obj.cdpPaused = message.cdpPaused);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetCdpPaused);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.cdpPaused = (_b = object.cdpPaused) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
const baseMsgSetCdpPausedResponse = {};
exports.MsgSetCdpPausedResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetCdpPausedResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetCdpPausedResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetCdpPausedResponse);
        return message;
    },
};
const baseMsgReturnStablecoinWithInterestInCollateral = {
    creator: "",
    principalAmount: "",
    interestCdpDenom: "",
    interestCdpAmount: "",
    debtor: "",
};
exports.MsgReturnStablecoinWithInterestInCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.principalAmount !== "") {
            writer.uint32(18).string(message.principalAmount);
        }
        if (message.interestCdpDenom !== "") {
            writer.uint32(26).string(message.interestCdpDenom);
        }
        if (message.interestCdpAmount !== "") {
            writer.uint32(34).string(message.interestCdpAmount);
        }
        if (message.debtor !== "") {
            writer.uint32(42).string(message.debtor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.principalAmount = reader.string();
                    break;
                case 3:
                    message.interestCdpDenom = reader.string();
                    break;
                case 4:
                    message.interestCdpAmount = reader.string();
                    break;
                case 5:
                    message.debtor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.principalAmount =
            object.principalAmount !== undefined && object.principalAmount !== null
                ? String(object.principalAmount)
                : "";
        message.interestCdpDenom =
            object.interestCdpDenom !== undefined && object.interestCdpDenom !== null
                ? String(object.interestCdpDenom)
                : "";
        message.interestCdpAmount =
            object.interestCdpAmount !== undefined &&
                object.interestCdpAmount !== null
                ? String(object.interestCdpAmount)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.principalAmount !== undefined &&
            (obj.principalAmount = message.principalAmount);
        message.interestCdpDenom !== undefined &&
            (obj.interestCdpDenom = message.interestCdpDenom);
        message.interestCdpAmount !== undefined &&
            (obj.interestCdpAmount = message.interestCdpAmount);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.principalAmount = (_b = object.principalAmount) !== null && _b !== void 0 ? _b : "";
        message.interestCdpDenom = (_c = object.interestCdpDenom) !== null && _c !== void 0 ? _c : "";
        message.interestCdpAmount = (_d = object.interestCdpAmount) !== null && _d !== void 0 ? _d : "";
        message.debtor = (_e = object.debtor) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgReturnStablecoinWithInterestInCollateralResponse = {};
exports.MsgReturnStablecoinWithInterestInCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCollateralResponse);
        return message;
    },
};
const baseMsgReturnStablecoinWithInterestInCdpTokens = {
    creator: "",
    principalAmount: "",
    interestCdpDenom: "",
    interestCdpAmount: "",
    debtor: "",
};
exports.MsgReturnStablecoinWithInterestInCdpTokens = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.principalAmount !== "") {
            writer.uint32(18).string(message.principalAmount);
        }
        if (message.interestCdpDenom !== "") {
            writer.uint32(26).string(message.interestCdpDenom);
        }
        if (message.interestCdpAmount !== "") {
            writer.uint32(34).string(message.interestCdpAmount);
        }
        if (message.debtor !== "") {
            writer.uint32(42).string(message.debtor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCdpTokens);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.principalAmount = reader.string();
                    break;
                case 3:
                    message.interestCdpDenom = reader.string();
                    break;
                case 4:
                    message.interestCdpAmount = reader.string();
                    break;
                case 5:
                    message.debtor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCdpTokens);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.principalAmount =
            object.principalAmount !== undefined && object.principalAmount !== null
                ? String(object.principalAmount)
                : "";
        message.interestCdpDenom =
            object.interestCdpDenom !== undefined && object.interestCdpDenom !== null
                ? String(object.interestCdpDenom)
                : "";
        message.interestCdpAmount =
            object.interestCdpAmount !== undefined &&
                object.interestCdpAmount !== null
                ? String(object.interestCdpAmount)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.principalAmount !== undefined &&
            (obj.principalAmount = message.principalAmount);
        message.interestCdpDenom !== undefined &&
            (obj.interestCdpDenom = message.interestCdpDenom);
        message.interestCdpAmount !== undefined &&
            (obj.interestCdpAmount = message.interestCdpAmount);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCdpTokens);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.principalAmount = (_b = object.principalAmount) !== null && _b !== void 0 ? _b : "";
        message.interestCdpDenom = (_c = object.interestCdpDenom) !== null && _c !== void 0 ? _c : "";
        message.interestCdpAmount = (_d = object.interestCdpAmount) !== null && _d !== void 0 ? _d : "";
        message.debtor = (_e = object.debtor) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgReturnStablecoinWithInterestInCdpTokensResponse = {};
exports.MsgReturnStablecoinWithInterestInCdpTokensResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCdpTokensResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCdpTokensResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgReturnStablecoinWithInterestInCdpTokensResponse);
        return message;
    },
};
const baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens = {
    creator: "",
    debtor: "",
    collateralDenom: "",
    minCollateralAmount: "",
    debtDenom: "",
    debtAmount: "",
    interestCdpDenom: "",
    interestCdpAmount: "",
};
exports.MsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.minCollateralAmount !== "") {
            writer.uint32(34).string(message.minCollateralAmount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(42).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(50).string(message.debtAmount);
        }
        if (message.interestCdpDenom !== "") {
            writer.uint32(58).string(message.interestCdpDenom);
        }
        if (message.interestCdpAmount !== "") {
            writer.uint32(66).string(message.interestCdpAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.minCollateralAmount = reader.string();
                    break;
                case 5:
                    message.debtDenom = reader.string();
                    break;
                case 6:
                    message.debtAmount = reader.string();
                    break;
                case 7:
                    message.interestCdpDenom = reader.string();
                    break;
                case 8:
                    message.interestCdpAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.minCollateralAmount =
            object.minCollateralAmount !== undefined &&
                object.minCollateralAmount !== null
                ? String(object.minCollateralAmount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.interestCdpDenom =
            object.interestCdpDenom !== undefined && object.interestCdpDenom !== null
                ? String(object.interestCdpDenom)
                : "";
        message.interestCdpAmount =
            object.interestCdpAmount !== undefined &&
                object.interestCdpAmount !== null
                ? String(object.interestCdpAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.minCollateralAmount !== undefined &&
            (obj.minCollateralAmount = message.minCollateralAmount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.interestCdpDenom !== undefined &&
            (obj.interestCdpDenom = message.interestCdpDenom);
        message.interestCdpAmount !== undefined &&
            (obj.interestCdpAmount = message.interestCdpAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.minCollateralAmount = (_d = object.minCollateralAmount) !== null && _d !== void 0 ? _d : "";
        message.debtDenom = (_e = object.debtDenom) !== null && _e !== void 0 ? _e : "";
        message.debtAmount = (_f = object.debtAmount) !== null && _f !== void 0 ? _f : "";
        message.interestCdpDenom = (_g = object.interestCdpDenom) !== null && _g !== void 0 ? _g : "";
        message.interestCdpAmount = (_h = object.interestCdpAmount) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse = {};
exports.MsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse);
        return message;
    },
};
const baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateral = {
    creator: "",
    debtor: "",
    collateralDenom: "",
    minCollateralAmount: "",
    debtDenom: "",
    debtAmount: "",
    interestCdpDenom: "",
    interestCdpAmount: "",
};
exports.MsgLiquidateCollateralWithStablecoinAndInterestInCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.minCollateralAmount !== "") {
            writer.uint32(34).string(message.minCollateralAmount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(42).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(50).string(message.debtAmount);
        }
        if (message.interestCdpDenom !== "") {
            writer.uint32(58).string(message.interestCdpDenom);
        }
        if (message.interestCdpAmount !== "") {
            writer.uint32(66).string(message.interestCdpAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.minCollateralAmount = reader.string();
                    break;
                case 5:
                    message.debtDenom = reader.string();
                    break;
                case 6:
                    message.debtAmount = reader.string();
                    break;
                case 7:
                    message.interestCdpDenom = reader.string();
                    break;
                case 8:
                    message.interestCdpAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.minCollateralAmount =
            object.minCollateralAmount !== undefined &&
                object.minCollateralAmount !== null
                ? String(object.minCollateralAmount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.interestCdpDenom =
            object.interestCdpDenom !== undefined && object.interestCdpDenom !== null
                ? String(object.interestCdpDenom)
                : "";
        message.interestCdpAmount =
            object.interestCdpAmount !== undefined &&
                object.interestCdpAmount !== null
                ? String(object.interestCdpAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.minCollateralAmount !== undefined &&
            (obj.minCollateralAmount = message.minCollateralAmount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.interestCdpDenom !== undefined &&
            (obj.interestCdpDenom = message.interestCdpDenom);
        message.interestCdpAmount !== undefined &&
            (obj.interestCdpAmount = message.interestCdpAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.minCollateralAmount = (_d = object.minCollateralAmount) !== null && _d !== void 0 ? _d : "";
        message.debtDenom = (_e = object.debtDenom) !== null && _e !== void 0 ? _e : "";
        message.debtAmount = (_f = object.debtAmount) !== null && _f !== void 0 ? _f : "";
        message.interestCdpDenom = (_g = object.interestCdpDenom) !== null && _g !== void 0 ? _g : "";
        message.interestCdpAmount = (_h = object.interestCdpAmount) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse = {};
exports.MsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse);
        return message;
    },
};
const baseMsgConvertTokenInCdpToGroupTokens = {
    creator: "",
    denom: "",
};
exports.MsgConvertTokenInCdpToGroupTokens = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgConvertTokenInCdpToGroupTokens);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgConvertTokenInCdpToGroupTokens);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgConvertTokenInCdpToGroupTokens);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgConvertTokenInCdpToGroupTokensResponse = {};
exports.MsgConvertTokenInCdpToGroupTokensResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgConvertTokenInCdpToGroupTokensResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgConvertTokenInCdpToGroupTokensResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgConvertTokenInCdpToGroupTokensResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.AddRateStrategy = this.AddRateStrategy.bind(this);
        this.RemoveRateStrategy = this.RemoveRateStrategy.bind(this);
        this.AddAsset = this.AddAsset.bind(this);
        this.UpdateRateStrategy = this.UpdateRateStrategy.bind(this);
        this.UpdateAsset = this.UpdateAsset.bind(this);
        this.SupplyAsset = this.SupplyAsset.bind(this);
        this.WithdrawAsset = this.WithdrawAsset.bind(this);
        this.LockCollateral = this.LockCollateral.bind(this);
        this.UnlockCollateral = this.UnlockCollateral.bind(this);
        this.BorrowAsset = this.BorrowAsset.bind(this);
        this.RepayAsset = this.RepayAsset.bind(this);
        this.SupplyAssetAndLockCollateral =
            this.SupplyAssetAndLockCollateral.bind(this);
        this.UnlockCollateralAndWithdrawAsset =
            this.UnlockCollateralAndWithdrawAsset.bind(this);
        this.LiquidateCollateral = this.LiquidateCollateral.bind(this);
        this.SetLiquidationFee = this.SetLiquidationFee.bind(this);
        this.SetInterestFee = this.SetInterestFee.bind(this);
        this.RepayAssetWithCdpTokens = this.RepayAssetWithCdpTokens.bind(this);
        this.RepayAssetWithCollateral = this.RepayAssetWithCollateral.bind(this);
        this.CreateRewardScheme = this.CreateRewardScheme.bind(this);
        this.UpdateRewardScheme = this.UpdateRewardScheme.bind(this);
        this.ClaimRewards = this.ClaimRewards.bind(this);
        this.SetStablecoinInterestRate = this.SetStablecoinInterestRate.bind(this);
        this.SetStablecoinMintCap = this.SetStablecoinMintCap.bind(this);
        this.MintStablecoin = this.MintStablecoin.bind(this);
        this.ReturnStablecoin = this.ReturnStablecoin.bind(this);
        this.SetCompleteLiquidationThreshold =
            this.SetCompleteLiquidationThreshold.bind(this);
        this.SetMinimumCloseFactor = this.SetMinimumCloseFactor.bind(this);
        this.SetSmallLiquidationSize = this.SetSmallLiquidationSize.bind(this);
        this.LiquidateCollateralWithCdpTokens =
            this.LiquidateCollateralWithCdpTokens.bind(this);
        this.LiquidateCollateralWithCollateral =
            this.LiquidateCollateralWithCollateral.bind(this);
        this.LiquidateCollateralWithStablecoin =
            this.LiquidateCollateralWithStablecoin.bind(this);
        this.SetStalePriceGracePeriod = this.SetStalePriceGracePeriod.bind(this);
        this.SetCdpPaused = this.SetCdpPaused.bind(this);
        this.ReturnStablecoinWithInterestInCdpTokens =
            this.ReturnStablecoinWithInterestInCdpTokens.bind(this);
        this.ReturnStablecoinWithInterestInCollateral =
            this.ReturnStablecoinWithInterestInCollateral.bind(this);
        this.LiquidateCollateralWithStablecoinAndInterestInCdpTokens =
            this.LiquidateCollateralWithStablecoinAndInterestInCdpTokens.bind(this);
        this.LiquidateCollateralWithStablecoinAndInterestInCollateral =
            this.LiquidateCollateralWithStablecoinAndInterestInCollateral.bind(this);
        this.ConvertTokenInCdpToGroupTokens =
            this.ConvertTokenInCdpToGroupTokens.bind(this);
    }
    AddRateStrategy(request) {
        const data = exports.MsgAddRateStrategy.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "AddRateStrategy", data);
        return promise.then((data) => exports.MsgAddRateStrategyResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveRateStrategy(request) {
        const data = exports.MsgRemoveRateStrategy.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "RemoveRateStrategy", data);
        return promise.then((data) => exports.MsgRemoveRateStrategyResponse.decode(new minimal_1.default.Reader(data)));
    }
    AddAsset(request) {
        const data = exports.MsgAddAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "AddAsset", data);
        return promise.then((data) => exports.MsgAddAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateRateStrategy(request) {
        const data = exports.MsgUpdateRateStrategy.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "UpdateRateStrategy", data);
        return promise.then((data) => exports.MsgUpdateRateStrategyResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateAsset(request) {
        const data = exports.MsgUpdateAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "UpdateAsset", data);
        return promise.then((data) => exports.MsgUpdateAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    SupplyAsset(request) {
        const data = exports.MsgSupplyAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SupplyAsset", data);
        return promise.then((data) => exports.MsgSupplyAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    WithdrawAsset(request) {
        const data = exports.MsgWithdrawAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "WithdrawAsset", data);
        return promise.then((data) => exports.MsgWithdrawAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    LockCollateral(request) {
        const data = exports.MsgLockCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LockCollateral", data);
        return promise.then((data) => exports.MsgLockCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    UnlockCollateral(request) {
        const data = exports.MsgUnlockCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "UnlockCollateral", data);
        return promise.then((data) => exports.MsgUnlockCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    BorrowAsset(request) {
        const data = exports.MsgBorrowAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "BorrowAsset", data);
        return promise.then((data) => exports.MsgBorrowAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    RepayAsset(request) {
        const data = exports.MsgRepayAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "RepayAsset", data);
        return promise.then((data) => exports.MsgRepayAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    SupplyAssetAndLockCollateral(request) {
        const data = exports.MsgSupplyAssetAndLockCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SupplyAssetAndLockCollateral", data);
        return promise.then((data) => exports.MsgSupplyAssetAndLockCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    UnlockCollateralAndWithdrawAsset(request) {
        const data = exports.MsgUnlockCollateralAndWithdrawAsset.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "UnlockCollateralAndWithdrawAsset", data);
        return promise.then((data) => exports.MsgUnlockCollateralAndWithdrawAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    LiquidateCollateral(request) {
        const data = exports.MsgLiquidateCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LiquidateCollateral", data);
        return promise.then((data) => exports.MsgLiquidateCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetLiquidationFee(request) {
        const data = exports.MsgSetLiquidationFee.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetLiquidationFee", data);
        return promise.then((data) => exports.MsgSetLiquidationFeeResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetInterestFee(request) {
        const data = exports.MsgSetInterestFee.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetInterestFee", data);
        return promise.then((data) => exports.MsgSetInterestFeeResponse.decode(new minimal_1.default.Reader(data)));
    }
    RepayAssetWithCdpTokens(request) {
        const data = exports.MsgRepayAssetWithCdpTokens.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "RepayAssetWithCdpTokens", data);
        return promise.then((data) => exports.MsgRepayAssetWithCdpTokensResponse.decode(new minimal_1.default.Reader(data)));
    }
    RepayAssetWithCollateral(request) {
        const data = exports.MsgRepayAssetWithCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "RepayAssetWithCollateral", data);
        return promise.then((data) => exports.MsgRepayAssetWithCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateRewardScheme(request) {
        const data = exports.MsgCreateRewardScheme.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "CreateRewardScheme", data);
        return promise.then((data) => exports.MsgCreateRewardSchemeResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateRewardScheme(request) {
        const data = exports.MsgUpdateRewardScheme.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "UpdateRewardScheme", data);
        return promise.then((data) => exports.MsgUpdateRewardSchemeResponse.decode(new minimal_1.default.Reader(data)));
    }
    ClaimRewards(request) {
        const data = exports.MsgClaimRewards.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "ClaimRewards", data);
        return promise.then((data) => exports.MsgClaimRewardsResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetStablecoinInterestRate(request) {
        const data = exports.MsgSetStablecoinInterestRate.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetStablecoinInterestRate", data);
        return promise.then((data) => exports.MsgSetStablecoinInterestRateResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetStablecoinMintCap(request) {
        const data = exports.MsgSetStablecoinMintCap.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetStablecoinMintCap", data);
        return promise.then((data) => exports.MsgSetStablecoinMintCapResponse.decode(new minimal_1.default.Reader(data)));
    }
    MintStablecoin(request) {
        const data = exports.MsgMintStablecoin.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "MintStablecoin", data);
        return promise.then((data) => exports.MsgMintStablecoinResponse.decode(new minimal_1.default.Reader(data)));
    }
    ReturnStablecoin(request) {
        const data = exports.MsgReturnStablecoin.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "ReturnStablecoin", data);
        return promise.then((data) => exports.MsgReturnStablecoinResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetCompleteLiquidationThreshold(request) {
        const data = exports.MsgSetCompleteLiquidationThreshold.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetCompleteLiquidationThreshold", data);
        return promise.then((data) => exports.MsgSetCompleteLiquidationThresholdResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetMinimumCloseFactor(request) {
        const data = exports.MsgSetMinimumCloseFactor.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetMinimumCloseFactor", data);
        return promise.then((data) => exports.MsgSetMinimumCloseFactorResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetSmallLiquidationSize(request) {
        const data = exports.MsgSetSmallLiquidationSize.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetSmallLiquidationSize", data);
        return promise.then((data) => exports.MsgSetSmallLiquidationSizeResponse.decode(new minimal_1.default.Reader(data)));
    }
    LiquidateCollateralWithCdpTokens(request) {
        const data = exports.MsgLiquidateCollateralWithCdpTokens.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LiquidateCollateralWithCdpTokens", data);
        return promise.then((data) => exports.MsgLiquidateCollateralWithCdpTokensResponse.decode(new minimal_1.default.Reader(data)));
    }
    LiquidateCollateralWithCollateral(request) {
        const data = exports.MsgLiquidateCollateralWithCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LiquidateCollateralWithCollateral", data);
        return promise.then((data) => exports.MsgLiquidateCollateralWithCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    LiquidateCollateralWithStablecoin(request) {
        const data = exports.MsgLiquidateCollateralWithStablecoin.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LiquidateCollateralWithStablecoin", data);
        return promise.then((data) => exports.MsgLiquidateCollateralWithStablecoinResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetStalePriceGracePeriod(request) {
        const data = exports.MsgSetStalePriceGracePeriod.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetStalePriceGracePeriod", data);
        return promise.then((data) => exports.MsgSetStalePriceGracePeriodResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetCdpPaused(request) {
        const data = exports.MsgSetCdpPaused.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "SetCdpPaused", data);
        return promise.then((data) => exports.MsgSetCdpPausedResponse.decode(new minimal_1.default.Reader(data)));
    }
    ReturnStablecoinWithInterestInCdpTokens(request) {
        const data = exports.MsgReturnStablecoinWithInterestInCdpTokens.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "ReturnStablecoinWithInterestInCdpTokens", data);
        return promise.then((data) => exports.MsgReturnStablecoinWithInterestInCdpTokensResponse.decode(new minimal_1.default.Reader(data)));
    }
    ReturnStablecoinWithInterestInCollateral(request) {
        const data = exports.MsgReturnStablecoinWithInterestInCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "ReturnStablecoinWithInterestInCollateral", data);
        return promise.then((data) => exports.MsgReturnStablecoinWithInterestInCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    LiquidateCollateralWithStablecoinAndInterestInCdpTokens(request) {
        const data = exports.MsgLiquidateCollateralWithStablecoinAndInterestInCdpTokens.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LiquidateCollateralWithStablecoinAndInterestInCdpTokens", data);
        return promise.then((data) => exports.MsgLiquidateCollateralWithStablecoinAndInterestInCdpTokensResponse.decode(new minimal_1.default.Reader(data)));
    }
    LiquidateCollateralWithStablecoinAndInterestInCollateral(request) {
        const data = exports.MsgLiquidateCollateralWithStablecoinAndInterestInCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "LiquidateCollateralWithStablecoinAndInterestInCollateral", data);
        return promise.then((data) => exports.MsgLiquidateCollateralWithStablecoinAndInterestInCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConvertTokenInCdpToGroupTokens(request) {
        const data = exports.MsgConvertTokenInCdpToGroupTokens.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "ConvertTokenInCdpToGroupTokens", data);
        return promise.then((data) => exports.MsgConvertTokenInCdpToGroupTokensResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
